import axios from 'axios'
import { environment } from '@/data/environment/'

export default {
  namespaced: true,
  state: {
    statusGetAddressOptional: null,
    statusSetAddressOptional: null,
    activarAddresOptional: [],
    activarAddresOptionalConfigMessage: '',
    listClients: [],
  },
  mutations: {
    setListClients (state, data) {
      state.listClients = data
    },
    setAddressOptional (state, data) {
      state.activarAddresOptional = data
    },
    setResponseUpdateAddressOptionalConfig (state, data) {
      state.statusSetAddressOptional = data
    },
    setResponseGetAddressOptional (state, data) {
      state.statusGetAddressOptional = data
    },
    setResponseAddressOptionalMsg (state, data) {
      state.activarAddresOptionalConfigMessage = data
    },
  },
  actions: {
    getListClients ({ commit }) {
      const endpoint = '/api/getClients'
      const url = environment.HIOPOSWEBSERVICES + endpoint
      axios
        .create()
        .get(url)
        .then(response => {
          commit('setListClients', response.data)
        })
        .catch(function (error) {
          console.log(error.message)
        })
    },
    getAddresOptional ({ commit }, data) {
      let params = 'IdCompania=' + -1
      if (JSON.parse(atob(localStorage.getItem('uid'))).rol !== 'Administrador' && JSON.parse(atob(localStorage.getItem('uid'))).rol !== 'AdminI+D' && JSON.parse(atob(localStorage.getItem('uid'))).rol.trim() !== 'Desarrollador') {
        console.log(JSON.parse(atob(localStorage.getItem('uid'))).rol.trim);
        console.log('Desarrollador');

        params = 'IdCompania=' + JSON.parse(atob(localStorage.getItem('uid'))).idcompania
      } else {
        params = 'IdCompania=' + data.IdCompania
      }

      const endpoint = '/api/getAddressOptional?'
      const url = environment.HIOPOSWEBSERVICES + endpoint + params

      axios
        .create()
        .get(url)
        .then(response => {
            commit('setAddressOptional', response.data.Data)
          if (response.data.Error) {
            commit('setResponseGetAddressOptional', true)
            commit('setResponseAddressOptionalMsg', 'Hubo un error obteniendo la configuración de dirección opcional. Intentelo nuevamente.')
          } else {
            commit('setResponseGetAddressOptional', false)
            commit('setResponseAddressOptionalMsg', 'Configuración de dirección opcional consultada exitosamente.')
          }
        })
        .catch(function (error) {
          commit('setResponseGetAddressOptional', true)
          commit('setResponseAddressOptionalMsg', 'No pudo obtener  configuración de dirección opcional. Intentelo nuevamente.')
          console.log(error.message)
        })
    },
    updateAddressOptional ({ commit }, data) {
      const endpoint = '/api/updateAddressOptional'
      const url = environment.HIOPOSWEBSERVICES + endpoint

      if (JSON.parse(atob(localStorage.getItem('uid'))).rol !== 'Administrador' && JSON.parse(atob(localStorage.getItem('uid'))).rol !== 'AdminI+D' && JSON.parse(atob(localStorage.getItem('uid'))).rol.trim() !== 'Desarrollador') {
        data.IdCompania = JSON.parse(atob(localStorage.getItem('uid'))).idcompania
      }

      axios
        .create()
        .put(url, data)
        .then(response => {
          console.log(response)
            if (response.data.Error) {
              commit('setResponseUpdateAddressOptionalConfig', true)
              commit('setResponseAddressOptionalMsg', 'Hubo un error guardando la configuración de dirección opcional. Intentelo nuevamente.')
            } else {
              commit('setResponseUpdateAddressOptionalConfig', false)
              commit('setResponseAddressOptionalMsg', 'Configuración de cambio de dirección opcional guardada exitosamente.')
            }
        })
        .catch(function (error) {
          commit('setResponseUpdateAddressOptionalConfig', true)
          commit('setResponseAddressOptionalMsg', 'No pudo obtener información de la configuración de dirección opcional.')
          console.log(error.message)
        })
    },
    setUpdateStatusResponse ({ commit }, data) {
      commit('setResponseUpdateAddressOptionalConfig', data)
    },
    statusGetAddressOptional ({ commit }, data) {
      commit('setResponseGetAddressOptional', data)
    },
  },
}
